import { AdvancedFiltersComponentModule, AdvancedFiltersService } from '@b2b/common/components/advanced-filters';
import { CartDirectiveModule } from '@b2b/common/directives';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { PermissionsService } from '@b2b/common/services/permissions';
import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { TODO, Timestamp, UIBModal } from '@b2b/types/core';
import uiRouter from '@uirouter/angularjs';
import angular, { ISCEService } from 'angular';

export const ProgramsListControllerModule = angular
  .module('acme.view.application.programs.list.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.auth',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.viewState',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    SidebarServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.service.templates.helpers',
    'acme.common.service.themesHelper',
    'acme.common.service.featureToggle',
    CartServiceModule,
    CartDirectiveModule,
    AdvancedFiltersComponentModule,
    'acme.view.application.programs.createOrderModal.controllers',
    'acme.view.application.modals.confirmCustom.controllers',
    'acme.view.application.programs.instance.edit.cancelModal.controllers',
    'acme.view.application.programs.instance.edit.removeModal.controllers',
    'acme.view.application.programs.instance.edit.restoreModal.controllers',
    'acme.view.application.programs.modals.confirmSuspendedEventOrder.controllers',
    'acme.view.application.programs.modals.createPrivateEvent.controllers',
  ])
  .controller('ProgramsListController', [
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    '$uibModal',
    '$sce',
    'ApiService',
    'CalendarService',
    'HelpersService',
    'PermissionsService',
    'SidebarService',
    'NoticeFactory',
    'GridStateFactory',
    'ViewStateService',
    'GridDefinitionFactory',
    'UserPreferencesService',
    'TemplatesHelpersService',
    'CustomFieldsData',
    'ThemesHelperService',
    'FeatureToggleService',
    'CartService',
    'AuthService',
    'AdvancedFiltersService',
    function (
      $scope: TODO,
      $state: TODO,
      $filter: TODO,
      $timeout: TODO,
      $uibModal: TODO,
      $sce: ISCEService,
      ApiService: TODO,
      CalendarService: TODO,
      HelpersService: TODO,
      PermissionsService: PermissionsService,
      sidebarService: SidebarService,
      NoticeFactory: NoticeFactory,
      GridStateFactory: TODO,
      ViewStateService: TODO,
      GridDefinitionFactory: TODO,
      UserPreferencesService: TODO,
      TemplatesHelpersService: TODO,
      CustomFieldsData: TODO,
      ThemesHelperService: ThemesHelperService,
      FeatureToggleService: TODO,
      CartService: CartService,
      AuthService: TODO,
      advancedFiltersService: AdvancedFiltersService
    ) {
      const ctrl = {
        cartService: CartService,

        gridDefinition: new GridDefinitionFactory(),

        selected: false as
          | {
              id: number;
              level: any;
              tickets: any[];
              event:
                | {
                    priceList: { prices: any[] };
                  }
                | false;
            }
          | false,
        isLoaded: false,
        showFullDetails: false,

        analytics: undefined,

        eventRequest: false,
        isCSR: false,
        actionItemsSet: false,
        userPreferencesLoaded: false,
        viewId: '',

        addModal: {} as UIBModal<any>,
        createModal: {} as UIBModal<any>,
        showMessageModal: {} as UIBModal<any>,
        suspendedModal: {} as UIBModal<any>,
        privateEventModal: {} as UIBModal<any>,

        startDate: '' as Timestamp | Date,
        endTime: '' as Timestamp | Date,
        startTime: '' as Timestamp | Date,
        searchQuery: '',

        model: [] as any[],
        typed: [] as any[],
        filtered: [] as any[],
        notice: new NoticeFactory(),

        emailSetting: 'always',
        company: ThemesHelperService.getCompany(),

        customFields: [] as any[],
        advancedFiltersFields: [] as any[],
        paramsCustomFields: {
          operator: 'and',
          fields: [] as any[],
        },

        gridState: new GridStateFactory(),

        pageSize: 50,
        eventListGridName: $state.current.name + '.grid0',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
        headerDateFormat: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

        searchEventType: {},

        eventTypes: [
          {
            name: 'all',
            label: 'All events',
          },
          {
            name: 'private',
            label: 'Partner events',
          },
          {
            name: 'offSchedule',
            label: 'Events from order requests',
          },
        ],

        resourceRequests: {},

        resourceRequestTypes: [
          {
            name: 'all',
            label: 'With/Without requests',
          },
          {
            name: 'any',
            label: 'At least one request',
          },
          {
            name: 'none',
            label: 'No requests',
          },
        ],

        // TODO: Check why are there 2 different spellings for 'canceled'
        showListType: {} as { name: 'active' | 'suspended' | 'canceled' | 'cancelled' | 'deleted' },

        listTypes: [
          {
            name: 'active',
            label: 'Active',
            notes: '(includes suspended events)',
          },
          {
            name: 'canceled',
            label: 'Canceled',
            notes: '',
          },
          {
            name: 'deleted',
            label: 'Deleted',
            notes: '',
          },
          {
            name: 'suspended',
            label: 'Suspended',
            notes: '',
          },
        ],

        analyticsDateType: {},

        analyticsDateTypes: [
          {
            name: 'revenueForDate',
            label: 'Selected Date',
          },
          {
            name: 'revenueToday',
            label: 'Today',
          },
          {
            name: 'revenueLastSevenDays',
            label: 'Last Week',
          },
          {
            name: 'revenueNextSevenDays',
            label: 'Next Week',
          },
        ],

        optionsOverride: {
          data: 'programsList.model',
          rowClasses:
            "{ 'ui-grid-row-header-cell': col.isRowHeader, 'private-event': (row.entity.type === 'private') || row.entity.offSchedule, 'programs-list-canceled-row': (row.entity.showCanceledState && row.entity.isCanceled) }",
          getRowClass: function (params) {
            if (params.data.type === 'private' || params.data.offSchedule) {
              return 'private-event';
            } else if (params.data.isCanceled && params.data.showCanceledState) {
              return 'programs-list-canceled-row';
            } else {
              return null;
            }
          },
          columnDefs: [
            {
              field: 'view',
              displayName: 'View',
              width: 50,
              onCellNavClick: function (row, col) {
                ctrl.optionsOverride.appScopeProvider.onDblClick(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents text-center"><span data-ng-style="row.entity.colorCategoryStyle"></span> <a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
              visible: true,
              enableHiding: false,
              enableSorting: false,
              suppressSizeToFit: true,
            },
            {
              field: 'admissionType',
              displayName: 'Type',
              headerTooltip: true,
              width: 30,
              cellTemplate:
                '<div class="ui-grid-cell-text" ng-class="col.colIndex()">' +
                '<span title="Suspended event" data-ng-show="row.entity.isSuspended">' +
                '<span class="fa fa-exclamation-triangle programs-list-admin-admission-type suspended" role="presentation"></span><span class="sr-only">Suspended event</span>' +
                '</span>' +
                '<span title="Template: {{ row.entity.name }}" data-ng-show="row.entity.fieldStatus.modified && !row.entity.isSuspended">' +
                '<span class="fa fa-unlink programs-list-admin-admission-type" role="presentation"></span><span class="sr-only">Unlinked from template</span>' +
                '</span>' +
                '<span title="General Admission" data-ng-show="!row.entity.fieldStatus.modified && row.entity.admissionType === \'generalAdmission\' && !row.entity.isSuspended">' +
                '<span class="fa fa-asterisk programs-list-admin-admission-type" role="presentation"></span><span class="sr-only">General admission template</span>' +
                '</span>' +
                '</div>',
              cellRenderer: function (params) {
                let value = '<div class="ui-grid-cell-text" ng-class="col.colIndex()">';
                if (params.data.isSuspended) {
                  value =
                    value +
                    '<span title="Suspended event">' +
                    '<span class="fa fa-exclamation-triangle programs-list-admin-admission-type suspended" role="presentation"></span>' +
                    '<span class="sr-only">Suspended event</span>' +
                    '</span>';
                } else if (params.data.fieldStatus.modified) {
                  value =
                    value +
                    '<span title="Template: ' +
                    params.data.name +
                    '"' +
                    '<span class="fa fa-unlink programs-list-admin-admission-type" role="presentation"></span>' +
                    '<span class="sr-only">Unlinked from template</span>' +
                    '</span>';
                } else {
                  if (params.data.admissionType === 'generalAdmission') {
                    value =
                      value +
                      '<span title="General Admission"' +
                      '<span class="fa fa-asterisk programs-list-admin-admission-type" role="presentation"></span>' +
                      '<span class="sr-only">General admission template</span>' +
                      '</span>';
                  }
                }
                value = value + '</div>';
                return value;
              },
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
            },
            {
              field: 'id',
              displayName: 'Event Id',
              visible: false,
            },
            {
              field: 'formattedStartTime',
              displayName: 'Start Time',
              width: 90,
              colId: 'startTime',
              sort: {
                direction: 'asc',
              },
            },
            {
              field: 'name',
              displayName: 'Event Name',
              visible: true,
            },
            {
              field: 'organization.name',
              displayName: 'Organization Name',
              visible: false,
            },
            {
              field: 'scheduleName',
              displayName: 'Schedule Name',
              visible: true,
            },
            {
              field: 'resourceRequestDisplay',
              displayName: 'Resources',
              visible: true,
              minWidth: 150,
              colId: 'requestSummary',
            },
            {
              field: 'sold',
              displayName: 'Sold',
              width: 60,
              visible: true,
            },
            {
              field: 'reserved',
              displayName: 'Reserved',
              width: 80,
              visible: true,
            },
            {
              field: 'available',
              displayName: 'Available',
              width: 80,
              visible: true,
            },
            {
              field: 'checkedIn',
              displayName: 'Checked In',
              width: 90,
              visible: true,
            },
          ],
          appScopeProvider: {
            onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
              ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
            },
            onDataGridSortChange: function (grid, columns, page) {
              ctrl.onDataGridSortChange(grid, columns, page);
            },
            onDblClick: function (item) {
              ctrl.onDblClick(item);
            },
            cancel: function (id, row) {
              ctrl.cancel(id, row);
            },
            createOrder: function (id, item) {
              ctrl.createOrder(id, item);
            },
            listAdminBooking: function (id) {
              ctrl.listAdminBooking(id);
            },
            remove: function (id) {
              ctrl.remove(id);
            },
            restore: function (id) {
              ctrl.restore(id);
            },
            onDataGridSelectionChange: function (row, e) {
              $scope.$emit('Cart::Close');
              if (ctrl.useCart && ctrl.showDetails) {
                ctrl.onDataGridSelectionChange(row, e);
              }
            },
          },
        },

        paramTemplateName: $state.params.templateName || '',
        paramTemplateId: $state.params.templateId || '',
        paramStartTime: $state.params.startTime || '',

        useCart: false,
        showDetails: false,

        cartEvents: [] as any[],

        init: function () {
          const startDate = this.getToday();
          const endTime = new Date();

          endTime.setHours(23);
          endTime.setMinutes(59);
          endTime.setSeconds(59);

          this.showListType = this.initListType();

          this.isCSR = PermissionsService.check('CSR');
          this.viewId = $state.current.name;

          this.useCart = FeatureToggleService.check('TENANT_CART');

          if (this.useCart) {
            this.cartService.getCart().then(this.success.getCart, this.error.getCart);
          }

          if (CustomFieldsData.data && CustomFieldsData.data.success) {
            this.setCustomFields(CustomFieldsData);
          }

          this.setListActionIcons();

          this.gridDefinition.init(
            this.eventListGridName,
            this.optionsOverride,
            this.viewId,
            $state.current.data.enablePreferences
          );

          if (CalendarService.current.eventsStartTimeTracker) {
            this.startDate = new Date(
              CalendarService.current.eventsStartTimeTracker.getFullYear(),
              CalendarService.current.eventsStartTimeTracker.getMonth(),
              CalendarService.current.eventsStartTimeTracker.getDate(),
              0,
              0,
              0
            );
          } else {
            this.startDate = startDate;
          }
          this.startTime = CalendarService.toISO8601(this.startDate);
          this.endTime = CalendarService.toISO8601(endTime);

          $scope.$emit('Application::contentTitleChange', {
            title: 'Events List',
            buttonRight: {
              label: '+ Private Event',
              action: function () {
                ctrl.createPrivateEvent();
              },
            },
          });

          $scope.$on('pageContent::startLoad', function (event, data) {
            const self = ctrl;
            let startDate;

            if (data && data.from && data.from.name === 'application.programs.list') {
              switch (data.to.name) {
                case 'application.programsInstance':
                case 'application.orders.checkout':
                case 'application.programs.listAdminBooking':
                case 'application.programs.listAdminOrder':
                case 'application.scheduler.detail':
                case 'application.cart':
                  break;

                default:
                  startDate = self.getToday();
                  CalendarService.current.eventsStartTimeTracker = false;
                  self.startDate = startDate;

                  ViewStateService.resetState('programs.create.order.modal.accounts');
              }
            }
          });

          this.getNotificationPreference();

          $scope.$watch('programsList.startDate', this.onStartDateUpdate);
          $scope.$watch('programsList.searchEventType', this.onSearchEventTypeUpdate);
          $scope.$watch('programsList.searchRequestType', this.onSearchRequestTypeUpdate);

          $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
          $scope.$on('$destroy', $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad));

          $scope.$on('$destroy', $scope.$watch('programsList.cartService.initted', this.onCartServiceInitted));
          $scope.$on(
            '$destroy',
            $scope.$watch('programsList.cartService.events.events.length', this.onCartServiceInitted)
          );

          $scope.$on('$destroy', function () {
            CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
          });
        },

        initData: function (e, data) {
          const self = ctrl;
          const props = self.gridDefinition.getGridState();
          self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
          self.search();
        },

        initListType: function () {
          let result = ctrl.listTypes[0]; // [0]: actives, by default

          if (ctrl.paramTemplateId) {
            result = ctrl.listTypes[1]; // [1]: deleted
          }

          return result;
        },

        getNotificationPreference: function () {
          if (this.company.hasOwnProperty('notificationPreference')) {
            this.emailSetting = this.company.notificationPreference;
          }
        },

        setCustomFields: function (customFieldsData) {
          const list = customFieldsData.data.payload.list;
          let atIndex = this.optionsOverride.columnDefs.length;

          this.customFields = list;
          this.advancedFiltersFields = advancedFiltersService.mapCustomFieldsToAdvancedFiltersFields(this.customFields);

          //ideally insert at after "scheduleName", Otherwise at end
          for (let i = 0, ii = this.optionsOverride.columnDefs.length; i < ii; i++) {
            if (this.optionsOverride.columnDefs[i].field === 'resourceRequestDisplay') {
              atIndex = i;
              break;
            }
          }
          angular.forEach(list, function (customField, key) {
            ctrl.optionsOverride.columnDefs.splice(atIndex, 0, {
              field: customField.internalLabel,
              displayName: customField.label,
              visible: false,
            });
            atIndex++;
          });
        },

        setListActionIcons: function () {
          const self = ctrl;

          self.optionsOverride.columnDefs.splice(3, 0, {
            field: 'startDate',
            displayName: 'Date',
            width: 80,
            visible: false,
            cellFilter: 'date: "' + self.dateFormat + '"',
            cellFormatter: function (item) {
              return $filter('date')(item.value, self.dateFormat);
            },
          } as any);

          if (PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE'])) {
            self.optionsOverride.columnDefs.push({
              field: 'order',
              displayName: 'Order',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                if (!row.entity.offSchedule && !row.entity.addedToCart) {
                  ctrl.optionsOverride.appScopeProvider.createOrder(row.entity.id, row.entity);
                }
              },
              cellTemplate:
                '<div class="ui-grid-cell-text" ng-class="col.colIndex()">' +
                '<a title="Create Order" data-ng-show="!row.entity.offSchedule && !row.entity.addedToCart" class="programs-list-link programs-list-manual-entry" data-ng-class="{\'programs-list-link-disabled\': row.entity.manuallyDeleted}" data-ng-click="grid.appScope.createOrder(row.entity.id)">' +
                '<span class="fa fa-ticket" role="presentation"></span><span class="sr-only">Create order for {{ row.entity.name }} - Opens Dialog</span>' +
                '</a>' +
                '<a title="Added to cart" data-ng-show="!row.entity.offSchedule && row.entity.addedToCart" class="programs-list-link programs-list-link-disabled programs-list-manual-entry">' +
                '<span class="fa fa-check" role="presentation"></span><span class="sr-only">{{ row.entity.name }} added to cart</span>' +
                '</a>' +
                '</div>',
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            } as any);
          }

          if (PermissionsService.check('ORDER_REBOOK')) {
            self.optionsOverride.columnDefs.push({
              field: 'booking',
              displayName: 'Rebook',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                if (!row.entity.offSchedule) {
                  ctrl.optionsOverride.appScopeProvider.listAdminBooking(row.entity.id);
                }
              },
              cellTemplate:
                '<div class="ui-grid-cell-text" ng-class="col.colIndex()"><a title="Rebook" role="button" data-ng-hide="row.entity.offSchedule" class="programs-list-link programs-list-rebook" data-ng-class="{\'programs-list-link-disabled\': row.entity.manuallyDeleted}" data-ng-click="grid.appScope.listAdminBooking(row.entity.id)"><span class="fa fa-calendar" role="presentation"></span><span class="sr-only">Rebook {{ row.entity.name }}</span></a></div>',
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            } as any);
          }

          if (PermissionsService.check(['EVENT_CANCEL'])) {
            self.optionsOverride.columnDefs.push({
              field: 'cancel',
              displayName: 'Cancel',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                ctrl.optionsOverride.appScopeProvider.cancel(row.entity.id, row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-text" ng-class="col.colIndex()"><a title="Cancel" role="button" class="programs-list-link programs-list-cancel" data-ng-class="{\'programs-list-link-disabled\': row.entity.manuallyDeleted}" data-permit="EVENT_CANCEL" data-ng-click="grid.appScope.cancel(row.entity.id, row)"><i role="presentation" class="fa fa-ban"></i><span class="sr-only">Cancel {{ row.entity.name }} - Opens Dialog</span></a></div>',
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            } as any);
          }

          if (PermissionsService.check(['EVENT_DELETE', 'EVENT_RESTORE'])) {
            self.optionsOverride.columnDefs.push({
              field: 'delete',
              displayName: 'Delete',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                if (row.entity.manuallyDeleted && !row.entity.offSchedule) {
                  ctrl.optionsOverride.appScopeProvider.restore(row.entity.id);
                } else if (!row.entity.offSchedule) {
                  ctrl.optionsOverride.appScopeProvider.remove(row.entity.id);
                }
              },
              cellTemplate:
                '<div class="ui-grid-cell-text" ng-class="col.colIndex()" data-ng-show="!row.entity.manuallyDeleted && !row.entity.offSchedule"><a title="Remove" role="button" class="programs-list-link programs-list-remove" data-permit="EVENT_DELETE" data-ng-click="grid.appScope.remove(row.entity.id)"><i role="presentation" class="fa fa-times-circle-o"></i><span class="sr-only">Delete {{ row.entity.name }} - Opens Dialog</span></a></div>' +
                '<div class="ui-grid-cell-text" ng-class="col.colIndex()" data-ng-show="row.entity.manuallyDeleted && !row.entity.offSchedule"><a title="Restore" role="button" class="programs-list-link programs-list-remove" data-permit="EVENT_RESTORE" data-ng-click="grid.appScope.restore(row.entity.id)"><i role="presentation" class="fa fa-undo"></i><span class="sr-only">Restore {{ row.entity.name }} - Opens Dialog</span></a></div>',
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            } as any);
          }
        },

        setListActionIconVisibility: function (listType) {
          if (listType) {
            switch (listType) {
              case 'canceled':
                this.gridDefinition.setColumnVisibility({
                  order: false,
                  delete: false,
                  cancel: false,
                  booking: false,
                });
                break;
              case 'deleted':
                this.gridDefinition.setColumnVisibility({
                  order: false,
                  delete: PermissionsService.check(['EVENT_DELETE', 'EVENT_RESTORE']),
                  cancel: false,
                  booking: false,
                });
                break;
              default:
                this.gridDefinition.setColumnVisibility({
                  order: PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE']),
                  delete: PermissionsService.check(['EVENT_DELETE', 'EVENT_RESTORE']),
                  cancel: PermissionsService.check(['EVENT_CANCEL']),
                  booking: PermissionsService.check('ORDER_REBOOK'),
                });
                break;
            }
          }
        },

        isShowDeletedEvents: function () {
          return ctrl.showListType && ctrl.showListType.name === 'deleted';
        },

        isShowCanceledEvents: function () {
          return ctrl.showListType && ctrl.showListType.name === 'canceled';
        },

        getEvents: function () {
          const params: {
            startTime: Timestamp;
            endTime: Timestamp;
            saleChannel?: string;
            resourceRequestFilter?: string;
            filter?: string;
            customFields?: string;
            states?: string;
          } = {
            startTime: CalendarService.toISO8601(this.startTime),
            endTime: CalendarService.toISO8601(this.endTime),
          };

          this.gridState.setPropertyValue('search', this.searchQuery);

          if (this.isCSR) {
            params.saleChannel = 'customerRep';
          }
          if (this.searchRequestType.name) {
            params.resourceRequestFilter = this.searchRequestType.name;
          }
          if (this.searchEventType.name && this.searchEventType.name === 'offSchedule') {
            params.filter = this.searchEventType.name;
          }

          if (this.paramsCustomFields.fields && this.paramsCustomFields.fields.length) {
            params.customFields = this.paramsCustomFields;
          }

          switch (this.showListType.name) {
            case 'all':
              params.states = 'active,suspended,cancelled';
              break;
            case 'canceled':
              params.states = 'cancelled';
              break;
            case 'suspended':
              params.states = 'suspended';
              break;
            default:
              params.states = 'active,suspended';
              break;
          }

          console.log('ProgramsListController::getEvents', this.startTime, this.endTime);
          ApiService.event
            .search($.extend(params, this.gridState.getGridState()))
            .then(this.success.getEvents, this.error.getEvents);
        },

        getCanceledEvents: function () {
          this.gridState.setPropertyValue('search', this.searchQuery);

          console.log('ProgramsListController::getCanceledEvents', this.startTime, this.endTime);
          ApiService.event
            .canceled(this.startTime, this.endTime, this.gridState.getGridState())
            .then(this.success.getCanceledEvents, this.error.getCanceledEvents);
        },

        getDeletedEvents: function () {
          const props: { startTime: Timestamp; templateId?: string; endTime?: Timestamp; requestFilter?: string } = {
            startTime: this.paramStartTime || this.startTime,
          };

          this.gridState.setPropertyValue('search', this.searchQuery);

          //paramTemplateId is only set when you are coming into this view from a different page.
          //in this case don't send end time.
          if (this.paramTemplateId) {
            props.templateId = this.paramTemplateId;
            console.log('ProgramsListController::getDeletedEvents', this.startTime, this.endTime);
          }
          //Get the deleted events for current date and time from events list page.
          else {
            props.endTime = this.endTime;
            console.log('ProgramsListController::getDeletedEvents', this.startTime, this.endTime);
          }
          if (this.searchRequestType.name) {
            props.requestFilter = this.searchRequestType.name;
          }
          ApiService.program.trash
            .list(props, this.gridState.getGridState())
            .then(this.success.getDeletedEvents, this.error.getDeletedEvents);
        },

        getAnalytics: function () {
          ApiService.analytics.revenue
            .summary($filter('date')(this.startDate, 'yyyy-MM-dd'))
            .then(this.success.getAnalytics, this.error.getAnalytics);
        },

        hasAnalytics: function () {
          return this.analytics && this.analytics.revenueToday;
        },

        selectEvent: function () {
          if (this.model.length) {
            if (this.membershipId && this.model.length > 1) {
              this.gridDefinition.selectRows([this.model[1]]);
            } else {
              this.gridDefinition.selectRows([this.model[0]]);
            }
          } else {
            this.gridDefinition.clearSelection();
            this.selected = false;
          }
        },

        getEvent: function (event) {
          ApiService.event.detail(event.id).then(this.success.getEvent, this.error.getEvent);
        },

        getEventTickets: function () {
          if (this.selected.event) {
            this.selected.tickets = this.selected.event.priceList.prices;
            this.updateSelection();
            //TODO: Restore quantities from the cart.
          }
        },

        getAnalyticsAmount: function (type) {
          let result = 0;
          if (this.analytics.hasOwnProperty(type)) {
            result = this.analytics[type].amount || 0;
          }
          return result;
        },

        getAnalyticsQuantity: function (type) {
          let result = 0;
          if (this.analytics.hasOwnProperty(type)) {
            result = this.analytics[type].quantity || 0;
          }
          return result;
        },

        reduce: function () {
          // Next tick
          $timeout(function () {
            const self = ctrl;

            self.filtered = $filter('filter')(self.typed, function (event) {
              const name = event.name || '';
              const value = name.toLowerCase();

              return value.indexOf(self.searchQuery.toLowerCase()) !== -1 ? event : null;
            });
          }, 0);
        },

        query: function () {
          const self = ctrl;
          self.gridState.setPropertyValue('search', self.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: self.eventListGridName });
        },

        search: function () {
          this.isLoaded = false;
          if (this.gridDefinition.userPreferencesLoaded) {
            if (this.isShowDeletedEvents()) {
              this.getDeletedEvents();
            } else {
              this.getEvents();
            }
          }
        },

        updateSelection: function () {
          const self = ctrl;
          let selectedEvent;

          if (this.selected && this.selected.tickets.length) {
            selectedEvent = this.cartEvents.filter(function (event) {
              return self.selected && event.eventId === self.selected.id;
            });

            if (selectedEvent.length && selectedEvent[0].tickets.length) {
              angular.forEach(this.selected.tickets, function (ticket) {
                for (let i = 0, ii = selectedEvent[0].tickets.length; i < ii; i++) {
                  if (selectedEvent[0].tickets[i].ticketingTypeId === ticket.personType.id) {
                    ticket.quantity = selectedEvent[0].tickets[i].quantity;
                    ticket.itemId = selectedEvent[0].tickets[i].itemId;
                  }
                }
              });
            }
          }
        },

        refresh: function () {
          const self = ctrl;
          self.cartEvents = self.cartService.events.getEvents();
          if (self.showDetails) {
            self.updateSelection();
          }
          self.updateEventsInCart();
        },

        updateEventsInCart: function () {
          const self = ctrl;

          if (this.useCart) {
            angular.forEach(this.model, function (event) {
              event.addedToCart = self.cartService.events.getById(event.id);
            });
          }
        },

        addToCart: function (event) {
          CartService.events.addToCart(event).then(this.success.addEventToCart, this.error.addEventToCart);
        },

        createCheckoutOrder: function (id, event) {
          const self = ctrl;

          self.createModal = $uibModal.open({
            templateUrl: 'views/application/views/programs/modals/createOrderModal.tpl.html',
            size: 'md',
            controller: 'ProgramsCreateOrderModalController',
            resolve: {
              currentEvent: function () {
                return event.instance;
              },
            },
          });

          // Invoked when modal completes with close(params)
          self.createModal.result.then(
            function (response) {
              self.notice.hideSuccessMessages();
              self.notice.hideErrorMessages();

              if (response.type === 'manual') {
                CalendarService.current.eventsStartTimeTracker = self.startDate;
                $state.go('application.programs.listAdminOrder', { id: id });
              } else if (response.type === 'retail') {
                CalendarService.current.eventsStartTimeTracker = self.startDate;
                $state.go('application.orders.checkout', { id: id });
              } else if (response.type === 'account') {
                CalendarService.current.eventsStartTimeTracker = self.startDate;
                $state.go('application.orders.checkout', { id: id, accountId: response.accountId });
              }
            },
            function () {
              // Do nothing
            }
          );
        },

        createOrder: function (id, item) {
          const self = ctrl;
          const event = self.findEvent(id);

          const upgradeDowngradeMembership = CartService.memberships.getUpgradeDowngradeMembership();
          const hasUpgradeDowngradeMembership = !!upgradeDowngradeMembership.length;

          if (event && !event.instance.manuallyDeleted && !event.instance.offSchedule) {
            if (hasUpgradeDowngradeMembership) {
              self.showMessageModal = $uibModal.open({
                templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
                size: 'md',
                controller: 'ConfirmCustomModalController',
                resolve: {
                  modalTitle: function () {
                    return 'Are you sure?';
                  },
                  modalMessage: function () {
                    return 'Please add membership and tickets separately. Once you Upgrade / Downgrade, tickets will reflect applicable benefits. ';
                  },
                  okText: function () {
                    return 'Buy Tickets First';
                  },
                  cancelText: function () {
                    return 'Upgrade / Downgrade Membership First';
                  },
                  hideOkText: function () {
                    return false;
                  },
                },
              });

              self.showMessageModal.result.then(function (data) {
                CartService.removeItem(upgradeDowngradeMembership[0].itemId).then(function () {
                  self.proceedToOrder(id, event);
                });
              });
            } else if (event.instance.isSuspended) {
              self.suspendedModal = $uibModal.open({
                templateUrl:
                  'views/application/views/programs/modals/confirmSuspendedEventOrder/confirmSuspendedEventOrder.tpl.html',
                size: 'md',
                controller: 'ProgramsModalsConfirmSuspendedEventOrderController',
                resolve: {
                  suspendedMessage: function () {
                    return 'You are creating an order for a suspended event, are you sure you want to continue?';
                  },
                },
              });

              self.suspendedModal.result.then(function (data) {
                self.proceedToOrder(id, event);
              });
            } else {
              self.proceedToOrder(id, event);
            }
          }
        },

        createPrivateEvent: function () {
          const self = ctrl;

          self.privateEventModal = $uibModal.open({
            templateUrl: 'views/application/views/programs/modals/createPrivateEvent/createPrivateEvent.tpl.html',
            size: 'md',
            controller: 'CreatePrivateEventController',
            resolve: {
              startTime: function () {
                return self.startTime;
              },
            },
          });

          self.privateEventModal.result.then(function (res) {
            self.search();
          });
        },

        proceedToOrder: function (id, event) {
          if (this.useCart) {
            this.addToCart(event.instance);
          } else {
            this.createCheckoutOrder(id, event);
          }
        },

        listAdminBooking: function (id) {
          const self = ctrl;
          const event = self.findEvent(id);

          if (event && !event.instance.manuallyDeleted && !event.instance.offSchedule) {
            if (event.instance.isSuspended) {
              self.suspendedModal = $uibModal.open({
                templateUrl:
                  'views/application/views/programs/modals/confirmSuspendedEventOrder/confirmSuspendedEventOrder.tpl.html',
                size: 'md',
                controller: 'ProgramsModalsConfirmSuspendedEventOrderController',
                resolve: {
                  suspendedMessage: function () {
                    return 'You are editing an order for a suspended event, are you sure you want to continue?';
                  },
                },
              });

              self.suspendedModal.result.then(function (data) {
                self.proceedToListAdminBooking(id);
              });
            } else {
              self.proceedToListAdminBooking(id);
            }
          }
        },

        proceedToListAdminBooking: function (id) {
          const self = ctrl;

          CalendarService.current.eventsStartTimeTracker = self.startDate;
          $state.go('application.programs.listAdminBooking', { id: id });
        },

        copyEventTypes: function () {
          this.typed = [];
          for (let i = 0, ii = this.model.length; i < ii; i++) {
            const event = this.model[i];
            const name = event.name || '';
            const value = name.toLowerCase();

            if (value.indexOf(this.searchQuery.toLowerCase()) !== -1) {
              if (this.searchEventType.name === 'all' || this.searchEventType.name === event.type) {
                this.typed.push(event);
              }
            }
          }
        },

        findEvent: function (id) {
          let result: { index: number; instance: any } | false = false;

          for (let i = 0, ii = this.model.length; i < ii; i++) {
            if (this.model[i].id === id) {
              result = {
                index: i,
                instance: this.model[i],
              };
            }
          }
          return result;
        },

        cancel: function (id, row) {
          const self = ctrl;
          const event = self.findEvent(id);

          if (event && !event.instance.manuallyDeleted) {
            console.log(event, row);
            self.addModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/instance/edit/modals/cancelEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsInstanceEditCancelModalController',
              resolve: {
                currentEvent: function () {
                  return event.instance;
                },
                emailSetting: function () {
                  return self.emailSetting;
                },
              },
            });

            // Invoked when modal completes with close(params)
            self.addModal.result.then(
              function (data) {
                const props = {
                  id: event.instance.id,
                  sendEmail: data.sendEmail || false,
                  sendEmailToResources: data.sendEmailToResources || false,
                  emailMessage: data.emailMessage || '',
                };

                self.notice.hideSuccessMessages();
                self.notice.hideErrorMessages();

                self.model[event.index].isCanceled = true;
                self.model[event.index].showCanceledState = !self.isShowCanceledEvents();

                ApiService.program.cancel.event(props).then(self.success.cancel, self.error.cancel);
              },
              function () {
                // Do nothing
              }
            );
          }
        },

        remove: function (id) {
          const self = ctrl;
          const event = self.findEvent(id);
          const props = {};

          if (event && !event.instance.offSchedule) {
            self.addModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/instance/edit/modals/removeEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsInstanceEditRemoveModalController',
              resolve: {
                currentEvent: function () {
                  return event.instance;
                },
                SoldQuantity: function () {
                  return event.instance.sold;
                },
                emailSetting: function () {
                  return self.emailSetting;
                },
              },
            });

            // Invoked when modal completes with close(params)
            self.addModal.result.then(
              function (sendEmail) {
                const props = {
                  id: event.instance.id,
                  sendEmail: sendEmail,
                };
                self.notice.hideSuccessMessages();
                self.notice.hideErrorMessages();

                self.model[event.index].manuallyDeleted = true;
                ApiService.program.instances.remove(props).then(self.success.remove, self.error.remove);
              },
              function () {
                // Do nothing
              }
            );
          }
        },

        getToday: function () {
          const date = new Date();
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
          return date;
        },

        isToday: function () {
          const today = this.getToday();
          const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0).getTime();
          const startDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth(),
            this.startDate.getDate(),
            0,
            0,
            0
          ).getTime();

          return startDate === date;
        },

        today: function () {
          this.startDate = this.getToday();
        },

        next: function () {
          this.startDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth(),
            this.startDate.getDate() + 1,
            0,
            0,
            0
          );
        },

        previous: function () {
          this.startDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth(),
            this.startDate.getDate() - 1,
            0,
            0,
            0
          );
        },

        hasEvents: function () {
          let result = true;
          if (this.isLoaded) {
            result = this.filtered instanceof Array && this.filtered.length > 0;
          }
          return result;
        },

        process: function (events) {
          for (let i = 0, ii = events.length; i < ii; i++) {
            const startDate = CalendarService.parseDate(events[i].startTime);
            const endDate = CalendarService.parseDate(events[i].endTime);

            events[i].startDate = startDate;
            events[i].formattedEndTime = $filter('date')(endDate, this.hourFormat);
            events[i].formattedStartTime = $filter('date')(startDate, this.hourFormat);
            events[i].isCanceled = events[i].state && events[i].state === 'canceled' ? true : false;
            events[i].showCanceledState = !this.isShowCanceledEvents();
            events[i].resourceRequestDisplay = this.getEventRequestsDisplay(events[i]);
            if (events[i].colorCategory && events[i].colorCategory.textColor) {
              events[i].colorCategoryStyle = TemplatesHelpersService.getColorCategoryStyle(events[i].colorCategory);
            }

            events[i].isSuspended = events[i].state && events[i].state === 'suspended' ? true : false;

            if (events[i].offSchedule) {
              events[i].scheduleName = 'None (from Order Request)';
            }

            if (events[i].manuallyDeleted) {
              events[i].available = events[i].available || 0;

              if (!events[i].sold) {
                events[i].sold = events[i].soldQuantity || 0;
              }

              if (!events[i].checkedIn) {
                events[i].checkedIn = events[i].checkInCount || 0;
              }
            }

            for (let j = 0, jj = this.customFields.length; j < jj; j++) {
              events[i][this.customFields[j].internalLabel] = HelpersService.getCustomFieldValue(
                events[i],
                this.customFields[j].label
              );
            }
          }

          return events;
        },

        processEvent: function (event) {
          event.thumbnail = this.getThumbnail(event);
          event.partialDescription = $sce.trustAsHtml(
            event.shortDescription
              ? HelpersService.strip(event.shortDescription, 300)
              : event.description
              ? HelpersService.strip(event.description, 300)
              : ''
          );
          event.longDescription = $sce.trustAsHtml(
            event.description ? event.description : event.shortDescription ? event.shortDescription : ''
          );

          return event;
        },

        getThumbnail: function (event) {
          let result = '';

          if (
            event &&
            event.images instanceof Array &&
            event.images.length &&
            event.images[0] &&
            event.images[0].thumbnail
          ) {
            result = event.images[0].thumbnail;
          } else {
            result = '/assets/img/global/no-image-landscape.png';
          }

          return result;
        },

        getEventRequestsDisplay: function (event) {
          let result = 'No requests';
          let personnelRequests = '';
          let equipmentRequests = '';
          let placesRequests = '';

          if (event.hasOwnProperty('requestSummary') && event.requestSummary.hasResourceRequests) {
            personnelRequests = this.getRequestsForCategory(event, 'people');
            equipmentRequests = this.getRequestsForCategory(event, 'equipment');
            placesRequests = this.getRequestsForCategory(event, 'place');

            if (personnelRequests || equipmentRequests || placesRequests) {
              result = personnelRequests || '';
              if (equipmentRequests) {
                result = result ? result + ', ' + equipmentRequests : equipmentRequests;
              }
              if (placesRequests) {
                result = result ? result + ', ' + placesRequests : placesRequests;
              }
            }
          }

          return result;
        },

        getRequestsForCategory: function (event, category) {
          let categorySuffix;
          let fulfilled = 0;
          let total = 0;
          let requests;
          let result = '';

          if (category === 'place') {
            categorySuffix = 'Places';
          } else {
            categorySuffix = HelpersService.cap(category);
          }

          if (event.requestSummary.hasOwnProperty(category)) {
            fulfilled = event.requestSummary[category].fulfilledRequestsCount
              ? event.requestSummary[category].fulfilledRequestsCount
              : 0;
            total = event.requestSummary[category].totalRequestsCount
              ? event.requestSummary[category].totalRequestsCount
              : 0;
            requests = total ? fulfilled + '/' + total : '';
            // Show resource name if total and fulfilled is 1 and only 1
            if (fulfilled === total && fulfilled === 1) {
              if (
                event.requestSummary[category].resourceNames instanceof Array &&
                event.requestSummary[category].resourceNames[0]
              ) {
                result = event.requestSummary[category].resourceNames[0];
              }
            } else {
              result = requests ? requests + ' ' + categorySuffix : '';
            }
          }

          return result;
        },

        launchScheduler: function () {
          const self = ctrl;
          CalendarService.current.eventsStartTimeTracker = self.startDate;
          $state.go('application.scheduler.detail');
        },

        updateListType: function (n, o) {
          switch (this.showListType.name) {
            case 'deleted':
            case 'canceled':
              this.query();
              break;

            default:
              this.paramTemplateName = '';
              this.paramTemplateId = '';
              this.paramStartTime = '';
              this.query();
              break;
          }
          this.setListActionIconVisibility(this.showListType.name);
        },

        restore: function (id) {
          const self = ctrl;
          const event = self.findEvent(id);

          if (event) {
            self.addModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/instance/edit/modals/restoreEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsInstanceEditRestoreModalController',
              resolve: {
                currentEvent: function () {
                  return event.instance;
                },
              },
            });

            // Invoked when modal completes with close(params)
            self.addModal.result.then(
              function (name) {
                self.notice.hideSuccessMessages();
                self.notice.hideErrorMessages();

                if (self.showListType.name == 'deleted') {
                  self.model.splice(event.index, 1);
                  self.copyEventTypes();
                  self.reduce();
                } else {
                  self.model[event.index].manuallyDeleted = false;
                }
                ApiService.program.trash.recover(event.instance.id).then(self.success.restore, self.error.restore);
              },
              function () {
                // Do nothing
              }
            );
          }
        },

        onDateFormatLoad: function (e, data) {
          ctrl.startingDay = UserPreferencesService.getStartDayOfWeek();
          ctrl.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
          ctrl.headerDateFormat = UserPreferencesService.getDateFormat('extendedDate', 'dateFormat');
          ctrl.hourFormat = UserPreferencesService.getHourFormat('standardTime', 'hourFormat');
        },

        showMessage: function (title, message) {
          const self = ctrl;

          if (message) {
            self.showMessageModal = $uibModal.open({
              templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
              size: 'md',
              controller: 'ReportsCreateShowMessageModalController',
              resolve: {
                currentTitle: function () {
                  return title;
                },
                currentMessage: function () {
                  return message;
                },
                safe: function () {
                  return true;
                },
              },
            });
            // Invoked when modal completes with close(params)
            self.showMessageModal.result.then(
              function () {},
              function () {
                // Do nothing
              }
            );
          }
        },

        success: {
          getEvents: function (response) {
            ctrl.model = ctrl.process(response.data.payload.list);
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.updateEventsInCart();

            if (!$scope.$$phase) {
              $scope.$apply();
            }

            ctrl.isLoaded = true;
            ctrl.gridDefinition.isLoaded = true;
            $timeout(function () {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: ctrl.gridDefinition.options.gridName,
                datasetLength: ctrl.model.length,
                totalItems: response.data.payload.pagination.count,
              });
              if (ctrl.showDetails) {
                ctrl.selectEvent();
              }
            }, 10);
          },

          getCanceledEvents: function (response) {
            console.log('ProgramsListController::success::getCanceledEvents', response);
            ctrl.model = ctrl.process(response.data.payload.list);
            ctrl.gridDefinition.isLoaded = true;
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.updateEventsInCart();

            if (!$scope.$$phase) {
              $scope.$apply();
            }

            ctrl.isLoaded = true;
            ctrl.gridDefinition.isLoaded = true;
            $timeout(function () {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: ctrl.gridDefinition.options.gridName,
                datasetLength: ctrl.model.length,
                totalItems: response.data.payload.pagination.count,
              });
              if (ctrl.showDetails) {
                ctrl.selectEvent();
              }
            }, 10);
          },

          getDeletedEvents: function (response) {
            console.log('ProgramsListController::success::getDeletedEvents', response);
            ctrl.model = ctrl.process(response.data.payload.list);
            ctrl.gridDefinition.isLoaded = true;
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.updateEventsInCart();

            if (!$scope.$$phase) {
              $scope.$apply();
            }

            ctrl.isLoaded = true;
            ctrl.gridDefinition.isLoaded = true;
            $timeout(function () {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: ctrl.gridDefinition.options.gridName,
                datasetLength: ctrl.model.length,
                totalItems: response.data.payload.pagination.count,
              });
              if (ctrl.showDetails) {
                ctrl.selectEvent();
              }
            }, 10);
          },

          getAnalytics: function (response) {
            const self = ctrl;

            self.analytics = response.data.payload;
            self.isLoaded = true;
          },

          cancel: function (response) {
            $scope.$broadcast('DataGrid::RefreshGrid');
          },

          remove: function (response) {
            $scope.$broadcast('DataGrid::RefreshGrid');
          },

          restore: function (response) {},

          addEventToCart: function (response) {
            $scope.$emit('Cart::Open');
          },

          getEvent: function (response) {
            const self = ctrl;
            if (self.selected) {
              self.selected.event = self.processEvent(response.data.payload);
              self.getEventTickets();
              self.showFullDetails = false;
            }
          },

          getCart: function () {
            ctrl.refresh();
          },
        },

        error: {
          getEvents: function (response, status) {
            ctrl.isLoaded = status !== 'abort';
          },

          getCanceledEvents: function (response, status) {
            ctrl.isLoaded = true;
          },

          getDeletedEvents: function () {
            ctrl.isLoaded = true;
          },

          getAnalytics: function (response) {
            ctrl.isLoaded = true;
          },

          cancel: function (response) {},

          remove: function (response) {},

          restore: function (response) {},

          addEventToCart: function (response) {
            ctrl.showMessage('An error occurred', response.data.error);
          },

          getEvent: function (response) {
            const self = ctrl;

            if (self.selected) {
              self.selected.event = false;
            }

            self.showFullDetails = false;
          },
          getCart: function () {
            ctrl.refresh();
          },
        },

        onStartDateUpdate: function (e, data) {
          const self = ctrl;
          const startDate = ctrl.startDate as Date;
          const endDate = new Date(ctrl.startDate);

          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);

          endDate.setHours(23);
          endDate.setMinutes(59);
          endDate.setSeconds(59);

          const startTime = CalendarService.toISO8601(startDate);
          self.startTime = startTime;
          self.endTime = CalendarService.toISO8601(endDate);

          self.analyticsDateTypes[0].label = $filter('date')(self.startDate, 'yyyy-MM-dd');

          self.gridState.setPropertyValue('search', self.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: self.eventListGridName });
        },

        onSearchEventTypeUpdate: function (n, o) {
          const self = ctrl;
          if (n && o && n.name !== o.name) {
            self.copyEventTypes();
            self.reduce();
            self.gridState.setPropertyValue('search', self.searchQuery);
            $scope.$broadcast('DataGrid::Search', { name: self.eventListGridName });
          }
        },

        onSearchRequestTypeUpdate: function (n, o) {
          const self = ctrl;
          if (n && o && n.name !== o.name) {
            self.gridState.setPropertyValue('search', self.searchQuery);
            $scope.$broadcast('DataGrid::Search', { name: self.eventListGridName });
          }
        },

        onDblClick: function (item) {
          const self = ctrl;
          if (!item.entity.manuallyDeleted) {
            CalendarService.current.eventsStartTimeTracker = self.startDate;
            $state.go('application.programsInstance', { id: item.entity.id });
          }
        },

        onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
          const self = ctrl;
          self.gridState.updateGridState(newPage, pageSize);
          if (sortField) {
            self.gridState.updateGridState(null, null, sortField, null);
          }
          if (sortDirection) {
            self.gridState.updateGridState(null, null, null, sortDirection);
          }
          self.search();
        },

        onDataGridSortChange: function (grid, columns, page) {
          const self = ctrl;
          const data = columns[0];
          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.search();
        },

        onDataGridSelectionChange: function (row, e) {
          const self = ctrl;

          if (row.isSelected) {
            self.selected = row.entity;
            self.getEvent(row.entity);
          }
        },

        onItemCountUpdated: function (n, o) {
          const self = ctrl;

          if (!self.model || n !== o) {
            self.refresh();
          }
        },

        onCartServiceInitted: function (n, o) {
          const self = ctrl;

          if (n !== o) {
            self.refresh();
          }
        },

        onAdvancedFiltersClear: function () {
          const self = ctrl;

          self.paramsCustomFields.fields = [];
          self.paramsCustomFields.operator = 'and';

          // Always use basic search when clearing advanced filters
          this.gridState.setPropertyValue('search', this.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: this.eventListGridName });
        },

        /**
         * @param {{ rawFilters: Record<string, any>; fields: Array<any>; operator: string; }} props
         */
        onAdvancedFiltersSubmit: function (props) {
          const self = ctrl;

          self.paramsCustomFields.fields = props.fields;
          self.paramsCustomFields.operator = props.operator;

          this.gridState.setPropertyValue('search', this.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: this.eventListGridName });

          sidebarService.hide();
        },

        onAdvancedFiltersClose: function () {
          sidebarService.hide();
        },
      };

      $scope.programsList = ctrl;
      ctrl.init();
    },
  ])
  .controller('ProgramsListDatePickerController', [
    '$scope',
    '$timeout',
    'UserPreferencesService',
    function ($scope, $timeout, UserPreferencesService) {
      const ctrl = {
        isOpen: false,

        dateOptions: {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false,
        } as {
          formatYear: string;
          startingDay: string;
          formatDayTitle: string;
          showWeeks?: boolean;
        },
        isPreferenceLoaded: false,
        init: function () {
          $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);
          $timeout(function () {
            ctrl.isPreferenceLoaded = true;
          }, 0);
        },

        today: function () {
          this.dt = new Date();
        },
        clear: function () {
          $scope.dt = null;
        },

        toggleMin: function () {
          $scope.minDate = $scope.minDate ? null : new Date();
        },
        open: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          this.isOpen = true;
        },

        onDateFormatLoad: function (e, data) {
          ctrl.dateOptions = {
            formatYear: 'yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          };
        },
      };

      $scope.programsListDatePicker = ctrl;
      $scope.programsListDatePicker.init();
    },
  ]).name;
